import React from "react";
import PropTypes from "prop-types";
import {useLocation} from "react-router-dom";
import BackButton from "../layout/button/BackButton";
import NextButton from "../layout/button/NextButton";
import SaveButton from "../layout/button/SaveButton";
import {Grid} from "@mui/material";

const StepperButtons = ({activeStep = 0, nbStep = 0, canSave = false, handleNext, handleBack, handleSave}) => {
    const location = useLocation();
    const path = location.pathname;
    return <React.Fragment >
        {
            nbStep &&
            <Grid container sx={{ marginBottom: { xs: '50px' } }} >
                 <Grid item xs={12} sm={6} justifyContent="flex-start">
                {
                    nbStep && handleBack && activeStep > 0 &&
                   
                    <BackButton
                        label={"Précédent"}
                        onClick={handleBack}
                    />
                    
                }
                </Grid>
            <Grid item xs={12} sm={6} display="flex" justifyContent="flex-end" >
                {nbStep && handleNext && (
                    <NextButton
                        label={activeStep + 1 === nbStep ? path.indexOf("register") > -1 ? "Valider" : "Valider et envoyer" : "Suivant"}
                        onClick={handleNext}
                    />
                )}

                {nbStep && handleSave && canSave && (
                    <SaveButton
                        label={"Sauvegarder"}
                        style={{ marginLeft: 15 }} // Use marginLeft instead of marginRight to space buttons correctly
                        onClick={handleSave}
                    />
                )}
            </Grid>
            </Grid>
        }
    </React.Fragment>
}

export default StepperButtons;
